import React, { ClipboardEvent, KeyboardEvent } from 'react';
import * as S from './EmailConfirmationModal.styles';

interface EmailConfirmationCodeInputsProps {
  code: string[];
  isDisabled: boolean;
  setInputRef: (index: number, element: HTMLInputElement | null) => void;
  onChange: (index: number, value: string) => void;
  onKeyDown: (index: number, event: KeyboardEvent<HTMLInputElement>) => void;
  onPaste: (index: number, event: ClipboardEvent<HTMLInputElement>) => void;
}

export function EmailConfirmationCodeInputs({
  code,
  isDisabled,
  setInputRef,
  onChange,
  onKeyDown,
  onPaste,
}: EmailConfirmationCodeInputsProps) {
  return (
    <S.CodeInputs>
      {code.map((digit, index) => (
        <S.CodeInput
          key={index}
          ref={element => {
            setInputRef(index, element);
          }}
          value={digit}
          type="search"
          inputMode="numeric"
          autoComplete="off"
          maxLength={1}
          disabled={isDisabled}
          onFocus={event => event.target.select()}
          onChange={event => onChange(index, event.target.value)}
          onKeyDown={event => onKeyDown(index, event)}
          onPaste={event => onPaste(index, event)}
        />
      ))}
    </S.CodeInputs>
  );
}
